module.exports = __webpack_public_path__ + "media/images/bulletlist-check-aa169cde600a5abc79ffef4593b2083d.png";